import React, { useEffect, useState } from "react";
import { memo } from "react";
import { calculateDeadlineAssignments } from "./calculateDeadlineAssignments";
import { calculateAdditionalAssignments } from "./calculateAdditionalAssignments";
import { calculateClassDeadlineAssignments } from "./calculateClassDeadlineAssignments";
import EmptyList from "./EmptyList";
import { calculateTopSix } from "./1_DeadlineHelpers/calculateTopSix";
import AssignmentList from "./1_DeadlineHelpers/2_List/AssignmentList";
import { useHusibuechContext } from "../../context/husibuechContext";

function DeadlineAssignmentsList({ type }) {
  const {
    personalDeadlineAssignments,
    setPersonalDeadlineAssignments,
    additionalAssignments,
    setAdditionalAssignments,
    relevantUserAssignments,
    relevantClassAssignments,
    classDeadlineAssignments,
    setClassDeadlineAssignments,
    topSix,
    setTopSix,
    showCourseAssignmentOnly,
    selectedCourse,
    calculatingDeadlines,
    setCalculatingDeadlines,
    showExams,
    showHomeworks,
    statusSelection,
    prioritySelection,
    schoolYearData,
    isALeader,
  } = useHusibuechContext();

  const [calculatingInProgress, setCalculatingInProgress] = useState(true);

  useEffect(() => {
    const calculateData = async () => {
      if (type === "personal") {
        await calculateDeadlineAssignments(
          relevantUserAssignments,
          setPersonalDeadlineAssignments,
        );
      } else if (type === "additional") {
        await calculateAdditionalAssignments(
          relevantUserAssignments,
          setAdditionalAssignments,
        );
      } else if (type === "topSix") {
        await calculateTopSix(
          schoolYearData,
          isALeader,
          showExams,
          showHomeworks,
          statusSelection,
          prioritySelection,
          setTopSix,
          selectedCourse,
        );
      } else if (type === "class") {
        // console.log("relClass,", relevantClassAssignments)
        await calculateClassDeadlineAssignments(
          relevantClassAssignments,
          setClassDeadlineAssignments,
          selectedCourse,
          showCourseAssignmentOnly,
        );
      }
      setCalculatingDeadlines(false);
      setCalculatingInProgress(false);
    };
    if (calculatingDeadlines && relevantUserAssignments) {
      // console.log("calculating deadlines for ", type, ": ", relevantUserAssignments)
      setCalculatingInProgress(true);
      calculateData();
    }
  }, [calculatingDeadlines, relevantUserAssignments]);

  const assignments =
    type === "personal"
      ? personalDeadlineAssignments
      : type === "additional"
        ? additionalAssignments
        : type === "topSix"
          ? topSix
          : classDeadlineAssignments;

  const hasAssignments = assignments?.length > 0;

  return (
    <>
      {calculatingInProgress && <p>Calculating deadlines...</p>}
      {!calculatingInProgress && (
        <>
          {hasAssignments ? (
            <AssignmentList
              type={type}
              assignments={assignments}
              classView={type === "class" || type === "topSix"}
            />
          ) : (
            <EmptyList type={type} />
          )}
        </>
      )}
    </>
  );
}

export default memo(DeadlineAssignmentsList);
